import React from 'react'

const Headerabout = ({image,title,childern}) => {
  return (
    <header className="header">
        <div className="header_container">
            <div className="heaadeer_image_1">
            <img src={image} alt="" />
            </div>
      
        <div className="header_content">
            <h1>{title}</h1>
            <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatem, mollitia! Molestias 
                      quos eveniet explicabo ab voluptas omnis minus.
            </p>
        </div>
        </div>
    </header>
  )
}

export default Headerabout
